import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

function VfView(props) {
  const { width, height, style, row, direction, justify, alignItems, alignSelf, xs, testID } =
    props;

  const viewStyle = {};

  // flex
  if (row) {
    viewStyle.flexDirection = 'row';
  }
  if (direction) {
    viewStyle.flexDirection = direction;
  }
  if (justify) {
    viewStyle.justifyContent = justify;
  }
  if (alignItems) {
    viewStyle.alignItems = alignItems;
  }
  if (alignSelf) {
    viewStyle.alignSelf = alignSelf;
  }

  // width height
  if (width) {
    viewStyle.width = width;
  }
  if (height) {
    viewStyle.height = height;
  }

  // splitting it in 12 columns
  if (xs) {
    viewStyle.width = (xs / 12) * 100 + '%';
  }

  // if you need different width in sm or md devices
  // const dimensionWidth = Dimensions.get('screen').width
  // if (sm && dimensionWidth > 600 && dimensionWidth <= 960) {
  //   viewStyle.width = sm / 12 * 100 + '%'
  // } else  if (md && dimensionWidth > 960 && dimensionWidth <= 1280) {
  //   viewStyle.width = md / 12 * 100 + '%'
  // }

  return (
    <View testID={testID} style={[viewStyle, style]}>
      {props.children}
    </View>
  );
}

VfView.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  alignSelf: PropTypes.string,
  testID: PropTypes.string,
  children: PropTypes.node,
  width: PropTypes.any,
  row: PropTypes.bool,
  direction: PropTypes.string,
  justify: PropTypes.string,
  alignItems: PropTypes.string,
  xs: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sm: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  md: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
};

export default VfView;
